var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSortIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39279 10.1598C5.16733 10.3551 4.83267 10.3551 4.60721 10.1598L1.88642 7.80356C1.46647 7.43988 1.72368 6.75 2.27921 6.75L7.72079 6.75C8.27632 6.75 8.53353 7.43988 8.11358 7.80356L5.39279 10.1598Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.60721 0.840167C4.83267 0.64491 5.16733 0.64491 5.39279 0.840167L8.11358 3.19644C8.53353 3.56012 8.27632 4.25 7.72079 4.25L2.27921 4.25C1.72368 4.25 1.46647 3.56012 1.88642 3.19644L4.60721 0.840167Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortIcon);
export default __webpack_public_path__ + "static/media/table-sort-icon.bcf50c1b0b4b1e6b15bb44a276603e4e.svg";
export { ForwardRef as ReactComponent };